const tipoExigibilidade = {
  EXIGIVEL: 'Exigível',
  NAO_INCIDENCIA: 'Não incidência',
  ISENCAO: 'Isenção',
  EXPORTACAO: 'Exportação',
  IMUNIDADE: 'Imunidade',
  EXI_SUS_DECI_JUDICIAL: 'Exigibilidade suspensa por decisão judicial',
  EXI_SUS_PROC_ADM: 'Exigibilidade suspensa por processo administrativo',
};

export default tipoExigibilidade;
